var React = require('react');

function PlusSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M416 208H272V64a32 32 0 0 0-32-32h-32a32 32 0 0 0-32 32v144H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32h144v144a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V304h144a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32z"}));
}

PlusSolid.defaultProps = {"aria-hidden":"true","data-icon":"plus","viewBox":"0 0 448 512"};

module.exports = PlusSolid;

PlusSolid.default = PlusSolid;
